import {mapState} from 'vuex'
import config from '@/config'
import moment from 'moment'
import { isUsaSummer } from "@/utils/index"
export default {
  props: {
    showInfo: {
      type: Boolean,
      default: false
    },
    showBack: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      zone: ''
    }
  },
  computed: {
    ...mapState(['status', 'code', 'market', 'stockname', 'dyna', 'region', 'symbol']),
    price() {
      let p = (this.dyna && this.dyna.LastPrice) || 0
      return this.isUsa() ? p.toFixed(3) : p.toFixed(2)
    },
    updown() {
      let p = (this.dyna && this.dyna.Updown) || 0
      return (p * 100).toFixed(2) + '%'
    },
    showTime() {
      return moment(this.getZoomTime(this.dyna.Time)).format('MM-DD HH:mm:ss')
    }
  },
  filters: {
    getStatus (type, region) {
      if (region === 'USA') return config.marketStatus['USA'][type] || ''
      return config.marketStatus[region === 'CN' ? 'CN' : 'GMG'][type] || ''
    },
    subStr (val) {
      if(val && val.length > 10) return `${val.substring(0, 10)}...`
      return val
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        path: `/${this.market}/${this.symbol}.html`,
      })
    },
    getZoomTime (t) {
      return t * 1000
    },
    isUsa() {
      return this.region === 'USA'
    },
    getCode (val) {
      return val
    }
  }
}